const t={path:"/api/v1/custom_jwt_account/authenticate",method:"POST"},a={path:"/api/v1/custom_jwt_account/link",method:"POST"};export{t as CustomJWTAuthenticate,a as CustomJWTLink};
